import { Clock } from 'lucide-react';
import { DrawerCallout } from '../../shared/activity-drawer/ui/DrawerCallout';

/**
 * Nel codice non esiste ancora un orario di lavoro per persona collegato al calendario:
 * le disponibilita' delle prenotazioni sono per tipo di appuntamento, non per utente.
 * Niente dati inventati: la scheda e' pronta per quando arriva la vista Team.
 */
export function WorkHoursTab() {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2 px-1.5 text-[13px] font-medium text-[#37352F] dark:text-white">
        <Clock className="h-4 w-4 text-[#787774]" strokeWidth={1.5} />Orario di lavoro
      </div>
      <DrawerCallout>In arrivo con la vista Team. Qui potrai indicare i giorni e le ore in cui lavori, così i colleghi sapranno quando proporti un appuntamento.</DrawerCallout>
    </div>
  );
}
